import {get,post} from '@/utils/request'
export const getBannerList = (query) => post('/banner/getBannerList.client', query)
export const uploadFile = (query) => post('/public/uploadFile.client', query)
export const shifuRuzhu = (query) => post('/shifu/shifuRuzhu.client', query)
export const getShifuMemberList = (query) => post('/shifu/getShifuMemberList.client', query)
export const getProductList = (query) => post('/product/getProductList.client', query)
export const getPtzzList = (query) => post('/banner/getPtzzList.client', query)
export const getArtice = (query) => post('/public/getArtice.client', query)
export const getProductTypeList = (query) => post('/producttype/getProductTypeList.client', query)
export const getDongtaiList = (query) => post('/dongtai/getDongtaiList.client', query)
export const saveHezuoJiameng = (query) => post('/public/saveHezuoJiameng.client', query)
export const getGzdmList = (query) => post('/public/getGzdmList.client', query)
export const getDictList = (query) => post('/public/getDictList.client', query)
export const getXlxzhList = (query) => post('/public/getXlxzhList.client', query)
export const orderCreate = (query) => post('/order/orderCreate.client', query)
export const getFwalList = (query) => post('/public/getFwalList.client', query)
export const getProductDetail = (query) => post('/product/getProductDetail.client', query)
export const getProductDetail2 = (query) => post('/product/getProductDetail2.client', query)
export const sendMsgCode = (query) => post('/public/sendMsgCode.client', query)
export const getArticleDetail = (query) => post('/public/getArticleDetail.client', query)
export const getChildAreaList = (query) => post('/shifu/getChildAreaList.client', query)
export const getShifuMemberDetailById = (query) => post('/shifu/getShifuMemberDetailById.client', query)
export const getCityList = (query) => post('/public/getCityList.client', query)
export const getProductTypeAllList = (query) => post('/producttype/getProductTypeAllList.client', query)
export const getXwzxList = (query) => post('/public/getXwzxList.client', query)
export const getFwalDetail = (query) => post('/public/getFwalDetail.client', query)
export const getLocationByIp = (query) => get('/public/getLocationByIp.client', query)
export const getMobileInfo = (query) => post('/public/getMobileInfo.client', query)
export const getMemberInfoByMobile = (query) => post('/shifu/getMemberInfoByMobile.client', query)
export const getProvicneCityArea = (query) => post('/shifu/getProvicneCityArea.client', query)
export const getPeizhiInfo = (query) => post('/public/getPeizhiInfo.client', query)


// WEBPACK FOOTER //
// ./src/api/api.js